import React, { useState } from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import { AppCard } from '@/layout/AppComponents';
import styled from 'styled-components';
import ReactDOMServer from 'react-dom/server';
import Scrollbars from 'react-custom-scrollbars';
import Translator from '../../../../components/helpers/Translator';
import IdentificationTab from './IdentificationTab';
import TrackingTab from './TrackingTab/TrackingTab';
import KPITab from './KPITab/KPITab';

export default function InecoRiskExpandedContainer({ elementID, active }) {
  const [activeTab, setActiveTab] = useState(active || 'identification');

  return (
    <Container
      bodyClassName="p-0 mt-2 rs-expanded-card-body"
      className="rs-expanded-card"
    >
      <Tabs defaultActiveKey={activeTab} onSelect={(v) => setActiveTab(v)}>
        <Tab
          eventKey="identification"
          title="Identificación"
          className="p-3 border border-top-0 bg-white"
        >
          {activeTab === 'identification' && (
            <Scrollbars style={{ height: '400px' }}>
              <IdentificationTab elementID={elementID} />
            </Scrollbars>
          )}
        </Tab>
        {/* <Tab eventKey="tracking" title="Seguimiento" className="p-0 bg-white">
          <Scrollbars style={{ height: '400px' }}>
            <TrackingTab elementID={elementID} />
          </Scrollbars>
        </Tab> */}
        <Tab eventKey="kpi" title="KPI" className="p-0 bg-white">
          <Scrollbars style={{ height: '400px' }}>
            <KPITab elementID={elementID} />
          </Scrollbars>
        </Tab>
      </Tabs>
    </Container>
  );
}

const Container = styled(AppCard)`
  .rs-expanded {
    border-top-right-radius: 0;
    border-top-left-radius: 0;
  }
  .rs-expanded-card-body {
    min-height: 120px;
  }
`;
